import { render, staticRenderFns } from "./InformeDetail.vue?vue&type=template&id=39b2c06a&scoped=true&"
import script from "./InformeDetail.vue?vue&type=script&lang=js&"
export * from "./InformeDetail.vue?vue&type=script&lang=js&"
import style0 from "./InformeDetail.vue?vue&type=style&index=0&id=39b2c06a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2c06a",
  null
  
)

export default component.exports